import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Repository } from 'typeorm';
import { TypesAdapter } from './dto/types.adapter';
import { Types } from './types.entity';
import { TypesDTO } from './dto/types.dto';
import { AllTypesResponse, CommonResponse, TypesResponse, TypesDropDownDto, ItemSubCategoryRequest } from '@gtpl/shared-models/masters'
import { TypesRequest } from './dto/types.request';
import appSettings from 'apps/services/config';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class TypesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Types) private typesRepository: Repository<Types>,
        private typesAdapter: TypesAdapter,
    ) { }
    async createTypes(typesDTO: TypesDTO, isUpdate: boolean): Promise<TypesResponse> {
        try {
            if (!isUpdate) {
                const req = { type: typesDTO.type, itemSubCategoryId: typesDTO.itemSubCategoryId }
                const typesEntity = await this.getTypes(req);
                if (typesEntity) {
                    throw new TypesResponse(false, 11104, 'Type already exists');
                }
            }
            else {
                const req = { type: typesDTO.type, itemSubCategoryId: typesDTO.itemSubCategoryId }
                const typesEntity = await this.getTypes(req);
                if (typesEntity) {
                    if (typesEntity.typeId != typesDTO.typeId) {
                        throw new TypesResponse(false, 11104, 'Type  already exists');
                    }
                }
            }
            const convertedTypesEntity: Types = this.typesAdapter.convertDtoToEntity(typesDTO, isUpdate);
            const savedTypesEntity: Types = await this.typesRepository.save(convertedTypesEntity);
            const savedTypesDTO: TypesDTO = this.typesAdapter.convertEntityToDto(savedTypesEntity);
            if (savedTypesDTO) {
                const response = new TypesResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'Type date Updated Successfully' : 'Type Created Successfully', savedTypesDTO);
                const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'Types', savedTypesDTO.typeId, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new TypesResponse(false, 11106, 'Type saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }
    /**
     * gets all Type details  
     * @returns all the Type details .
     */

    async getAllTypes(): Promise<AllTypesResponse> {
        console.log('function called')
        try {

            const manager = getManager()
            const query = 'select t.type as type,t.type_id as typeId,t.is_active as isActive,t.version_flag as versionFlag,i.item_sub_category as itemSubCategory from ' + appSettings.masters_db + '.types t left join ' + appSettings.masters_db + '.item_sub_categories i on i.item_sub_category_id = t.item_sub_category_id'


            const typesDTO: TypesDTO[] = await manager.query(query);
            if (typesDTO) {
                const response = new AllTypesResponse(true, 11208, "Type retrieved successfully", typesDTO);
                const newLogDto = new LogsDto(1,'view', 'Types', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                //   console.log('yest')
                throw new TypesResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getTypes(req: { type: string, itemSubCategoryId: number }): Promise<Types> {

        const response = await this.typesRepository.findOne({
            where: { type: req.type, itemSubCategoryId: req.itemSubCategoryId },
        });
        console.log(response, '?????????');
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    /**
     * It deactivates value    Type   
     * @param itemReq      Type as string
     * @returns true or false
     */

    async activateOrDeactivateTypes(typesReq: TypesRequest): Promise<TypesResponse> {
        try {
            const typesExists = await this.getTypesById(typesReq.typeId);
            if (typesExists) {
                if (typesReq.versionFlag !== typesExists.versionFlag) {
                    throw new TypesResponse(false, 10113, 'Someone updated the current Types information.Refresh and try again');
                } else {

                    const typesStatus = await this.typesRepository.update(
                        { typeId: typesReq.typeId },
                        { isActive: typesReq.isActive, updatedUser: typesReq.updatedUser });

                    if (typesExists.isActive) {
                        if (typesStatus.affected) {
                            const typesResponse: TypesResponse = new TypesResponse(true, 10115, 'Type is de-activated successfully');
                            return typesResponse;
                        } else {
                            throw new TypesResponse(false, 10111, 'Type is already deactivated');
                        }
                    } else {
                        if (typesStatus.affected) {
                            const typesResponse: TypesResponse = new TypesResponse(true, 10114, 'Type is activated successfully');
                            return typesResponse;
                        } else {
                            throw new TypesResponse(false, 10112, 'Type is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new TypesResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getTypesById(typeId: number): Promise<Types> {
        //  console.log(employeeId);
        const response = await this.typesRepository.findOne({
            where: { typeId: typeId },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getAllTypesDropDown(): Promise<CommonResponse> {
        try {
            const typesDto: TypesDropDownDto[] = [];
            // retrieves all plants
            const typesEntities: Types[] = await this.typesRepository.find({
                order: { type: "DESC" }, where: { isActive: true }
            });
            if (typesEntities.length > 0) {
                typesEntities.forEach(typesEntity => {
                    const convertedTypesDto = new TypesDropDownDto(typesEntity.typeId, typesEntity.type);
                    typesDto.push(convertedTypesDto);
                });
                const response = new CommonResponse(true, 11208, "Type retrieved successfully", typesDto);
                return response;
            } else {
                throw new TypesResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getTypesInfoById(typeId: number): Promise<CommonResponse> {
        try {
            const Response = await this.typesRepository.findOne({
                where: { typeId: typeId },
            });

            if (Response) {
                return new CommonResponse(true, 11111, 'Type Info Retrieved Successfully', Response);
            } else {
                return new CommonResponse(false, 99999, 'Not Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getTypesForItemSubcategoryId(req: ItemSubCategoryRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const query = 'select t.type_id as typeId,t.type as type from ' + appSettings.masters_db + '.types t where t.item_sub_category_id = ' + req.itemSubCategoryId


            const typesDTO = await manager.query(query);
            if (typesDTO) {
                const response = new AllTypesResponse(true, 11208, "Type retrieved successfully", typesDTO);
                return response;
            } else {
                //   console.log('yest')
                throw new TypesResponse(false, 99998, 'No Records Found');
            }
        } catch (error) {
            return error
        }
    }


}